<template>
  <v-dialog
    id="billingProcessDialog"
    :value="enableDialog"
    persistent
    width="700"
    @keydown.esc="cancelButtonClickEvent"
    @close="cancelButtonClickEvent"
  >
    <validation-observer ref="billingProcessFormValidator">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>請求計上</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <div class="mx-4 my-5 gray--text">
            現時点の売上情報を元に請求額を再計算します。<br />
            ※すでに本締め処理が行われている請求情報は再計算されません。
          </div>
          <v-form>
            <v-row>
              <v-col cols="12" md="6">
                <cs-date-picker
                  :date.sync="forms.billing_month"
                  type="month"
                  @dateChangedCallback="billingMonthChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      class="requiredMark"
                      rules="required"
                      name="請求月度"
                    >
                      <v-text-field
                        v-model="forms.billing_month"
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                        append-icon="mdi-calendar"
                        dense
                        hide-details="auto"
                        label="請求月度"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        readonly
                      />
                    </validation-provider>
                  </template>
                </cs-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <infinite-billing-auto-complete
                  :billing-id="forms.billing_address_id"
                  :self-tenant="true"
                  label="請求先"
                  @update:values="billingAddressChangedCallback"
                >
                  <template v-slot:append-outer>
                    <choose-billing-address-button
                      :small-button="true"
                      :self-tenant="true"
                      @choseBillingAddressCallback="choseBillingAddressCallback"
                    />
                  </template>
                </infinite-billing-auto-complete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="cancelButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            請求計上実行
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>

  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import ChooseBillingAddressButton from "@/driver/components/ChooseBillingAddressButton";
import InfiniteBillingAutoComplete from "@/driver/components/InfiniteBillingAutoComplete.vue";

export default {
  name: 'BillingProcessDialog',
  components: {
    InfiniteBillingAutoComplete,
    ChooseBillingAddressButton
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    changeDriver: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      showTargetDatePicker: false,
      forms: {
        billing_month: null,
        billing_address_id: null,
      },
    }
  },
  computed: {},
  watch: {
    enableDialog () {
      this.$nextTick(() => this.$refs.billingProcessFormValidator.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      this.forms.billing_month = this.$dayjs().format("YYYY-MM");
    },
  },
  created() {},
  methods: {
    ...mapActions('DriverSalesBillingProcess', {
      createBillingProcess: 'create',
    }),
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.createBillingProcess({params: this.forms}).then(() => {
        this.$emit('registerCallback')
      })
    },
    billingAddressChangedCallback (billing_id) {
      this.forms.billing_address_id = billing_id;
    },
    /**
     * 請求先選択ボタンからのダイアログのコールバック
     * @param item
     */
    choseBillingAddressCallback (item) {
      this.forms.billing_address_id = item.id;
    },
    /**
     * 請求月度変更　コールバック
     */
    billingMonthChangedCallback (value) {
      this.forms.billing_month = value;
    },
  }
}
</script>
